function decimalFormat(num) {
  return Number.parseFloat(num).toFixed(2);
}

module.exports = decimalFormat;
